import { z } from 'zod';
import { DriverAffiliationType, DriverFormType } from '@/api/apis/resources';
import { SelectItemType } from '@/types';
import { MAX_LENGTH_2000 } from '@/constants/form.constants';

export const BANNED_DRIVERS_DEFAULT_VALUES: DriverFormType = {
  firstName: '',
  lastName: '',
  affiliationType: DriverAffiliationType.None,
  txCenterProviderId: null,
  companyName: null,
  isBanned: true,
  phone: '',
  comment: '',
};

export const BANNED_DRIVERS_AFFILATION_PREFERENCES: SelectItemType[] = [
  { value: DriverAffiliationType.None, name: 'None' },
  { value: DriverAffiliationType.TMDX, name: 'TMDX Affiliate' },
  { value: DriverAffiliationType.TXCenterProvider, name: 'TX Center Provider' },
];

export const bannedDriversFormSchema = z.object({
  firstName: z.string().min(1, 'Provide First Name'),
  lastName: z.string().min(1, 'Provide Last Name'),
  affiliationType: z.enum(DriverAffiliationType).nullable(),
  txCenterProviderId: z.string().nullable(),
  txCenterProviderName: z.string().optional(),
  companyName: z.string().nullable(),
  phone: z.string().optional(),
  isBanned: z.boolean(),
  comment: z.string().max(MAX_LENGTH_2000, `Maximum length: up to ${MAX_LENGTH_2000} symbols`).optional(),
});
